<template>
  <div>
    <!-- 客服 浮动 -->
    
    <div v-if="!showTools">
      <div
        class="TextFlag"
        v-if="ActiveIndex == 1"
        :class="ActiveIndex == 1 ? 'right-enter-active' : 'right-leave-active'"
      >
        <!-- <div
          @click="onlineConsultation"
          id="nb_icon_wrap"
          style="overflow: hidden"
          class="
            Flagitem
            nb-icon-wrap nb-icon-base
            icon-right-center
            nb-icon-skin-0 nb-icon-icon nb-customer-icon-style
          "
        >
          <div class="showNav">
            <div class="TB_center">
              <div><img src="../static/images/zxkf.gif" alt="" /></div>
            </div>
          </div>
          <div class="Showcount">占位符</div>
        </div>-->
        <!-- <el-popover placement="left" title="" width="160" trigger="hover"> -->
        <!-- <div class="t1-one"> -->
        <!-- 1 -->
        <!-- 小工具暂时延后 -->
        <div class="Flagitem" @click="toGuidePage">
          <div class="showNav">
            <div class="TB_center" style="overflow: hidden; width: 70px">
              <img :src="ossPath + '/pages/home/guide_new.png'" alt="" />
              <div class="text-Nav">用户指南</div>
            </div>
          </div>
          <div class="Showcount">占位符</div>
        </div>
        <el-divider></el-divider>
        <div class="Flagitem" @click="showTools = true">
          <div class="showNav">
            <div class="TB_center" style="overflow: hidden; width: 70px">
              <img :src="ossPath + '/pages/home/icon_tools_new.png'" alt="" />
              <div class="text-Nav">小工具</div>
            </div>
          </div>
          <div class="Showcount">占位符</div>
        </div>
        <el-divider></el-divider>
        <!-- <template v-if="openQueryProductName">
          <div class="Flagitem" @click="clickQueryProductName">
            <div class="showNav">
              <div class="TB_center" style="overflow: hidden; width: 70px">
                <img :src="ossPath + '/pages/home/icon_product_name.png'" alt="" />
                <div class="text-Nav">品名试算</div>
              </div>
            </div>
            <div class="Showcount">占位符</div>
          </div>
          <el-divider></el-divider>
        </template> -->
        <div class="Flagitem">
          
          <el-popover
             :popper-options="{ boundariesElement: 'body' }"
              ref="dcPopover"
              popper-class="tool-popover"
              width="195"
              placement="left-bottom"
              trigger="hover">
            <div class="showNav" style="" slot="reference" @mouseenter="fn">
              <a :href="href_tel" style="text-decoration: none">
                <div class="TB_center">
                  <div class="TB_center" style="overflow: hidden; width: 70px">
                    <img :src="ossPath + '/pages/home/icon_online service_new.png'" alt />
                    <div class="text-Nav">联系平台</div>
                  </div>
                </div>
              </a>
            </div>
            <div class="" style="text-align: center">
              <p style="text-align: left; font-size: 16px;margin: 6px 0; font-weight: bold; color: #FF4D01">
                <span style="margin-right: 5px; font-size: 18px; color: #000000;">方式一</span>
                扫码联系在线客服
              </p>
              <img style="width: 150px; height: 150px;" :src="qrCodeImages.wxService" alt="微信咨询二维码" />
              <!-- <p style="font-size: 14px; padding-left: 4px">扫一扫联系平台客服</p> -->
              <div style="padding: 10px 0">
                <p style="text-align: left; font-size: 16px;margin: 6px 0; font-weight: bold; color: #FF4D01">
                  <span style="margin-right: 5px; font-size: 18px; color: #000000;">方式二</span>
                  客户端在线客服
                </p>
                <a :href="qrCodeImages.serviceUrl" target="_blank">
                  <el-button style="width: 150px;" type="primary" size="small">点击联系在线客服</el-button>
                </a>
              </div>
            </div>
          </el-popover>
          
          
          <div class="Showcount">占位符</div>
          <!-- <div class="star-t1"></div> -->
        </div>
        <!-- </div> -->
        <!-- </el-popover> -->
        <el-divider></el-divider>
        <!-- 2 -->
        <div class="Flagitem-1" slot="reference" style="display:none;">
          <div class="showNav" style="border-bottom: 1px solid #eee !important;">
            <a :href="href_tel" style="text-decoration: none">
              <div class="TB_center">
                <div class="TB_center" style="overflow: hidden; width: 70px">
                  <img :src="ossPath + '/pages/home/icon_contact.png'" alt />
                  <div class="text-Nav">联系我们</div>
                </div>
              </div>
            </a>
          </div>
          <div class="t1-one-1">
            <p style="font-size: 14px;margin: 14px 0;">客服热线:</p>
            <p style="font-size: 14px;margin: 6px 0;">400-992-1818</p>
          </div>
          <!-- <div class="Showcount">占位符</div> -->
          <div class="star-t1-1"></div>
        </div>
        <div class="Flagitem" slot="reference">
          <div class="showNav" style="">
            <a :href="href_tel" style="text-decoration: none">
              <div class="TB_center">
                <div class="TB_center" style="overflow: hidden; width: 70px">
                  <img :src="ossPath + '/pages/home/wechatGZH_new.png'" alt />
                  <div class="text-Nav">微信公众号</div>
                </div>
              </div>
            </a>
          </div>
          <div class="t1-one">
            <p style="font-size: 14px;margin: 6px 0;">微信公众号</p>
            <img
              style="width: 130px; height: 130px;"
              :src="qrCodeImages.gzh"
              alt="微信咨询二维码"
            />
          </div>
          <div class="Showcount">占位符</div>
          <div class="star-t1"></div>
        </div>
        <el-divider></el-divider>
        <!-- 5 -->

        <div class="Flagitem" slot="reference">
          <div class="showNav" :style="{borderBottom: scrollTopheight >= 750 ? '1px solid #eee' : 'none'}">
            <a :href="href_tel" style="text-decoration: none">
              <div class="TB_center">
                <div class="TB_center" style="overflow: hidden; width: 70px">
                  <img :src="ossPath + '/pages/home/icon_applets_new.png'" alt />
                  <div class="text-Nav">小程序</div>
                </div>
              </div>
            </a>
          </div>
          <div class="t1-one">
            <p style="font-size: 14px;margin: 6px 0;">小程序</p>
            <img style="width: 130px; height: 130px;" :src="qrCodeImages.applet" alt="微信咨询二维码" />
          </div>
          <div class="Showcount">占位符</div>
          <div class="star-t1"></div>
        </div>
        <!-- <el-divider></el-divider> -->

        <div class="Flagitem" @click="toTop" v-show="scrollTopheight >= 750">
          <div class="showNav">
            <div class="TB_center">
              <div>
                <img :src="ossPath + '/pages/home/icon_back_new.png'" alt="返回顶部" />
              </div>
              <div class="text-Nav">返回顶部</div>
            </div>
          </div>
          <div class="Showcount"></div>
        </div>
      </div>

      <div class="showIng">
        <div class="FlagitemC">
          <div class="TB_center" v-if="ActiveIndex == 1" @click="handleClick">
            <!-- <div style="width:50px height:50px"><img src="../static/images/shou.png" alt="" /></div> -->
            <div class="Image-Box">
              <img src="../static/images/shou.png" alt />
            </div>
          </div>
          <div class="TB_center" v-else @click="handleClick">
            <div class="Image-Box">
              <img src="../static/images/zhan.png" alt />
            </div>
          </div>
          <div class="Showcount">占位符</div>
        </div>
      </div>
    </div>
    <template v-if="openQueryProductName">
      <query-product-name
        :visible.sync="visibleQueryProductName"
        :need-customs-clearance="needCustomsClearance"
        :default-country-id="defaultCountryId"
        :default-group-id="defaultGroupId"
      />
    </template>

    <toolBar v-if="showTools" @hiddenTools="hiddenTools"></toolBar>
  </div>
</template>
<script>
import {qrCodeImages} from "../devParams.js";
import QueryProductName from "@common/queryProductName";
import toolBar from '@common/toolBar'
export default {
  components: {QueryProductName, toolBar},
  props:{
    openQueryProductName:Boolean,// 品名试算 是否开放按钮
    needCustomsClearance:Boolean,// 品名试算 是否 有清关相关逻辑
    defaultCountryId:[String,Number],// 品名试算 默认选中国家id,值不为空时，国家选中框禁用
    defaultGroupId:[String,Number],// 品名试算 默认团id,跟团详情页需要
  },
  data () {
    return {
      qrCodeImages,
      ActiveIndex: 1,
      scrollTopheight: "",
      href_tel: "",
      /* 品名试算 */
      visibleQueryProductName:false,
      showTools: false
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        if (this.showTools) this.hiddenTools()
        if (['/placeOrder/placeindexInfo/inquiryHall',
          '/placeOrder/publishedInquiry',
          '/placeOrder/inquiryTakeOrder',
          '/placeOrder/inquiryTakeOrder/success'].includes(this.$route.path)) {
            this.ActiveIndex = 0
          }
      }
    }
  },
  computed: {
    notInquiry() {
      return !['/placeOrder/placeindexInfo/inquiryHall',
          '/placeOrder/publishedInquiry',
          '/placeOrder/inquiryTakeOrder',
          '/placeOrder/inquiryTakeOrder/success'].includes(this.$route.path)
    }
  },
  methods: {
    fn() {
      this.$nextTick(()=> {
                        this.$refs.dcPopover.updatePopper() // 注意主要是这里
                    })
    },
    hiddenTools() {
      this.showTools = false
    },
    clickQueryProductName(){
      this.visibleQueryProductName = true;
    },
    // 在线咨询
    onlineConsultation () {
      window.open(
        "https://p.qiao.baidu.com/cps/chat?siteId=17320739&userId=34266456&siteToken=5e01b35862b5ca97b9b51380e3ae2b80",
        "_blank"
      )
    },
    toTop () {
      let top = document.documentElement.scrollTop || document.body.scrollTop
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
          50
        if (top <= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    },

    //   切换隐藏
    handleClick () {
      this.ActiveIndex = this.ActiveIndex === 0 ? 1 : 0
    },

    windowScroll () {
      // 滚动条距离页面顶部的距离
      // 以下写法原生兼容
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      this.scrollTopheight = scrollTop
      // console.log("高度=",this.scrollTopheight);
    },

    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    toGuidePage() {
      this.$router.push('/placeOrder/Guide')
    }
  },

  created () {
    if (this._isMobile()) {
      this.href_tel = "tel:400-992-1818"
    } else {
      this.href_tel = "javascript:void(0)"
    }
  },
  mounted () {
    window.addEventListener("scroll", this.windowScroll)
  },
};
</script>

<style scoped>
.TextFlag {
  position: fixed;
  width: 270px;
  z-index: 999;
  right: -200px;
  bottom: 250px;
  bottom: 18%;
  background-color: #fff;
  /* padding-left: 2px; */
  box-sizing: border-box;
  border-radius: 10px 0 0 10px;
  box-shadow: 10px 0px 10px 10px rgba(6, 2, 3, 0.13);
}
/* 侧边导航 */
.Flagitem {
  cursor: pointer;
  /* margin-top: 2px; */
  width: 260px;
  height: 88px;
  background: #ffffff;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  transition: width 0.5s;
  -webkit-transition: width 0.5s;
  /* border-radius: 10px 0 0 10px; */
  transition: transform 300ms;
  /* box-shadow: 0px 0px 10px 0px rgba(6, 2, 3, 0.13); */
}
.showNav {
  width: 74px;
  height: 86px;
  float: left;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}
.TB_center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.Showcount {
  width: 200px;
  height: 60px;
  float: left;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.showCouText {
  padding: 10px 0;
  width: 100%;
  float: left;
  font-size: 14px;
}
.kefu:hover {
  transform: translate(-10px, 0px);
  transition: transform 300ms;
  box-shadow: 0px 0px 39px 5px rgba(155, 155, 155, 0.32);
}
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 56px;
  margin: 0 7px;
  margin-top: -1px;
  background: #EEEEEE;
}
/* 收起展示 */
.showIng {
  position: fixed;
  width: 260px;
  height: 30px;
  z-index: 999;
  right: -200px;
  bottom: 11%;
}

.FlagitemC {
  cursor: pointer;
  margin-top: 2px;
  width: 260px;
  height: 30px;
  /* background: #ffffff; */
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  transition: width 0.5s;
  -webkit-transition: width 0.5s;
  border-radius: 10px 0 0 10px;
  transition: transform 300ms;
  /* box-shadow: 0px 0px 10px 0px rgba(6, 2, 3, 0.13); */
}
/* 过渡动画 */
.right-enter-active {
  animation: rightOut 0.5s ease;
}
.right-leave-active {
  animation: rightLevel 5s ease;
}
@keyframes rightOut {
  0% {
    transform: translateX(-150px);
    opacity: 0;
  }
  100% {
    transform: translateX(0px);
    opacity: 1;
  }
}
@keyframes rightLevel {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    transform: translateX(150px);
    opacity: 0;
  }
}

.Image-Box {
  width: 50px;
  height: 50px;
  background: #ffffff;
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-Nav {
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #331318;
  line-height: 18px;
}
</style>

<style lang="scss" scoped>
.Flagitem {
  padding-left: 2px;
  position: relative;
  &:first-of-type {
    border-radius: 10px 0 0 0;
  }
  &:nth-last-of-type(2) {
    border-radius: 0 0 0 10px;
  }
  &:hover {
    background: rgba(255, 77, 1, .1);
  }
}

.t1-one {
  position: absolute;
  right: 300px;
  width: 200px;
  min-height: 200px;
  background: white;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 2px 12px 0 #0000001a;
  display: none;
}

.Flagitem:hover .t1-one {
  display: block;
}
.star-t1 {
  position: absolute;
  height: 0px;
  width: 0px;
  right: 293px;
  border-top: 10px solid transparent;
  border-right: 10px solid white;
  transform: rotate(180deg);
  border-bottom: 10px solid transparent;
  display: none;
}
.Flagitem:hover .star-t1 {
  display: block;
}

.Flagitem-1 {
  position: relative;
}

.t1-one-1 {
  position: absolute;
  right: 300px;
  width: 200px;
  height: 80px;
  background: white;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 2px 12px 0 #0000001a;
  display: none;
}

.Flagitem-1:hover .t1-one-1 {
  display: block;
}
.star-t1-1 {
  position: absolute;
  height: 0px;
  width: 0px;
  right: 293px;
  border-top: 10px solid transparent;
  border-right: 10px solid white;
  transform: rotate(180deg);
  border-bottom: 10px solid transparent;
  display: none;
  top: 28px;
}
.Flagitem-1:hover .star-t1-1 {
  display: block;
}

.Flagitem-2 {
  position: relative;
}

.t1-one-2 {
  position: absolute;
  right: 300px;
  width: 200px;
  height: 200px;
  background: white;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 2px 12px 0 #0000001a;
  display: none;
}

.Flagitem-2:hover .t1-one-2 {
  display: block;
}
.star-t1-2 {
  position: absolute;
  height: 0px;
  width: 0px;
  right: 293px;
  border-top: 10px solid transparent;
  border-right: 10px solid white;
  transform: rotate(180deg);
  border-bottom: 10px solid transparent;
  display: none;
  top: 28px;
}
.Flagitem-2:hover .star-t1-2 {
  display: block;
}
</style>
<style>
.el-popover.tool-popover {
  /* min-width: 100px!important; */
  margin-left: -260px;
}
</style>



// WEBPACK FOOTER //
// common/serviceText.vue